import posthog from "posthog-js";

export default {
	install: () => {
		posthog.init(import.meta.env.VITE_POSTHOG_API_KEY, {
			api_host:
				import.meta.env.VITE_POSTHOG_API_HOST || "https://eu.i.posthog.com",
			ui_host: "https://eu.posthog.com",
			defaults: "2025-05-24",
			autocapture: false,
			loaded: (ph) => {
				if (process.env.NODE_ENV !== "production") {
					ph.opt_out_capturing(); // opts a user out of event capture
					posthog.set_config({ disable_session_recording: true });
				}
			},
		});

		(window as any).posthog = posthog;
	},
};
